import React, { memo } from 'react';
import styled from 'styled-components';

import { avatarTone } from './taskTones';

/** Первые буквы двух первых слов; «?» для пустого имени. */
export const initialsOf = (name?: string | null): string => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  return words
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase();
};

interface IAssigneeAvatarProps {
  /** Id сотрудника — по нему выбирается цвет (см. `avatarTone`). */
  id?: string | null;
  name?: string | null;
  size?: number;
}

/**
 * Цветные инициалы исполнителя (ТЗ 0109). Цвет — функция id, а не имени:
 * тёзки различаются, переименование не перекрашивает человека.
 *
 * Аватар всегда стоит РЯДОМ с именем, поэтому для читалки он скрыт: иначе имя
 * прозвучало бы дважды, второй раз — буквами инициалов.
 *
 * Свой `span`, а не antd `Avatar`: тот на каждом экземпляре подписывается на
 * брейкпоинты окна, а карточек на доске — сотни.
 */
export const AssigneeAvatar = memo(
  ({ id, name, size = 20 }: IAssigneeAvatarProps) => (
    <Circle aria-hidden="true" $size={size} $bg={avatarTone(id || name)}>
      {initialsOf(name)}
    </Circle>
  ),
);

AssigneeAvatar.displayName = 'AssigneeAvatar';

const Circle = styled.span<{ $size: number; $bg: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  color: #fff;
  font-size: ${({ $size }) => Math.max(10, Math.round($size * 0.45))}px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0;
  overflow: hidden;
`;
